module.exports = __webpack_public_path__ + "img/grand-vitara-silver-grafito.cc53a681.png";